import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme) => ({
    popupElement: {
        width: "100%",
        marginTop: 20,
    },
}));

export default function PlanNote(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    return (
        <TextField
            id="planNote"
            onChange={props.FilterWithPlanNote}
            defaultValue={props.planNote}
            value={!props.planNote || props.planNote === "null" ? "" : props.planNote}
            label={t("MaintenanceNote")}
            variant="outlined"
            size={props.size ?? "normal"}
            className={classes.popupElement}
        />
    );
}
